import React, { useState } from 'react'

import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';

import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

import { ReactComponent as AudianceAssistant } from "../../assets/audience_assistant.svg";
import { ReactComponent as DataWorkbench } from "../../assets/data_workbench.svg";
import { ReactComponent as Operations } from "../../assets/operations.svg";

import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';

import { NavLink } from "react-router-dom";
import classes from "./sidenav.module.scss";
import { ReactComponent as Navigator } from "../../assets/navigator.svg";


const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        '& .MuiDrawer-paper': {
            top: "66px",
        },
        variants: [
            {
                props: ({ open }) => open,
                style: {
                    ...openedMixin(theme),
                    '& .MuiDrawer-paper': openedMixin(theme),
                },
            },
            {
                props: ({ open }) => !open,
                style: {
                    ...closedMixin(theme),
                    '& .MuiDrawer-paper': closedMixin(theme),
                },
            },
        ],
    }),
);

const ListItem = styled(MuiListItem)(({ theme }) => ({
    padding: 0,
    '& .Mui-selected': {
        backgroundColor: '#32CD314D !important'
    }

}));

// Define your modules in an array for easier mapping
const sidenavModules = [
    {
        key: 'Audience Assistant',
        to: '',
        icon: <AudianceAssistant />,
        label: 'Audience Assistant',
        index: 0,
    },
    {
        key: 'Data Workbench',
        to: 'aggregator',
        icon: <DataWorkbench />,
        label: 'Data Workbench',
        index: 1,
    },
    {
        key: 'Campaign Brief',
        to: 'campaign-brief',
        icon: <SpeakerNotesIcon fontSize='medium'/>,
        label: 'Campaign Brief',
        index: 2,
    },
    {
        key: 'Operations',
        to: 'operations',
        icon: <Operations />,
        label: 'Operations',
        index: 3,
    },
    {
        key: 'Campaign Navigator',
        to: `http://campaignnavigatorcb.softcrylic.com/auth/callback`,
        icon: <Navigator />,
        label: 'Campaign Navigator',
        index: 4,
    },
];

const buildToIndexMap = items => new Map(items.map(({ to, index }) => [to, index]));
const toIndexMap = buildToIndexMap(sidenavModules);

function Sidenav({ open, onSidenavOpen }) {

    const path = window.location.pathname;
    const lastSegment = path.substring(path.lastIndexOf('/')+1);

    const [selectedIndex, setSelectedIndex] = useState(toIndexMap.get(lastSegment) ?? 0);
    

    const toggleSidenav = () => {
        onSidenavOpen((prevState) => !prevState);
    };

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    return (
        <Drawer
            variant="permanent"
            anchor="left"
            open={open}
        >
            <List
                sx={{
                    margin: open ? '24px' : '12px',
                    padding: '0',
                    '& .MuiButtonBase-root': {
                        padding: '8px ',
                        borderRadius: '8px '
                    },
                }}>
                {sidenavModules.map((mod) => (
                    <NavLink
                        key={mod.key}
                        className={({ isActive }) => 
                            isActive ? classes.activeLink : classes.inActiveLink
                        }
                        to={mod.to}
                    >
                        <ListItem
                            key={mod.key}
                            onClick={(event) => handleListItemClick(event, mod.index)}
                            sx={{ display: 'block' }}
                        >
                            {open ? (
                                <ListItemButton selected={selectedIndex === mod.index}>
                                    <ListItemIcon className={classes.icons} sx={{ minWidth: 0 }}>
                                        {mod.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        className={open ? classes.extendedSidenav : classes.collapsedSidenav}
                                        primary={mod.label}
                                    />
                                </ListItemButton>
                            ) : (
                                <Tooltip title={mod.label} placement="right">
                                    <ListItemButton selected={selectedIndex === mod.index}>
                                        <ListItemIcon className={classes.icons} sx={{ minWidth: 0 }}>
                                            {mod.icon}
                                        </ListItemIcon>
                                    </ListItemButton>
                                </Tooltip>
                            )}
                        </ListItem>
                    </NavLink>
                ))}
            </List>

            <List
                sx={{
                    margin: open ? '24px' : '12px',
                    padding: '0',
                    position: 'fixed',
                    bottom: open ? '12px' : '24px',
                    '& .MuiButtonBase-root': {
                        padding: '8px ',
                        borderRadius: '8px '
                    },
                }}>
                <ListItem onClick={toggleSidenav}>
                    <ListItemButton>
                        <ListItemIcon sx={{ minWidth: 0 }}>
                            {!open ? <ExitToAppIcon fontSize='medium' /> : <MenuOpenIcon fontSize='medium' />}
                        </ListItemIcon>
                        <ListItemText
                            className={open ? classes.extendedSidenav : classes.collapsedSidenav}
                            primary={'Collapse Sidebar'}
                            sx={{ marginLeft: '8px' }}
                        />
                    </ListItemButton>
                </ListItem>
            </List>
        </Drawer >
    )
}

export default Sidenav